import { Injectable, inject } from '@angular/core';
import { tap, iif, map, catchError, throwError, of } from 'rxjs';
import { environment } from '../environments/environment.prod';
import { ENDPOINTS } from './ENDPOINTS';
import { User } from '../interfaces/user.interface';
import { UserService } from './user.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userSrv = inject(UserService);
  private http = inject(HttpClient);
  register(payload: {
    email: string;
    password: string;
    rePassword: string;
    role: string;
  }) {
    return this.http.post<User>(ENDPOINTS.users.register, payload).pipe(
      tap((user) => {
        if (user.isVerified) this.saveUser(user);
      })
    );
  }
  login(payload: { email: string; password: string }) {
    return this.http.post<User>(ENDPOINTS.users.login, payload).pipe(
      tap((user) => {
        if (user.isVerified) this.saveUser(user);
      })
    );
  }
  logout() {
    this.userSrv.user$.next(null as any);
    localStorage.removeItem(environment.auth_token_key);
  }
  private saveUser(user: User) {
    this.userSrv.user$.next(user);
    if (user.token) {
      localStorage.setItem(environment.auth_token_key, user.token);
    }
  }
  getMyAccount() {
    const token = localStorage.getItem(environment.auth_token_key) as any;
    return iif(
      () => token,
      this.http.get<User>(ENDPOINTS.users.my_acc).pipe(
        tap((user) => this.saveUser(user)),
        map((user) => ({ type: 'SUCCESS', user })),
        catchError((response) => {
          this.logout();

          return throwError(() => ({ type: 'INVALID_TOKEN', user: null }));
        })
      ),
      of({ type: 'NO_TOKEN', user: null })
    );
  }
  forgottenPasswordEmail(body: { email: string }) {
    return this.http.post(ENDPOINTS.users.forgotten_password, body);
  }
  resetPassword(token: string, body: { newPassword: string; reNewPassword: string }) {
    return this.http.post(ENDPOINTS.users.reset_password(token), body);
  }
}
